
<input class="form-control" type="file" name="file" (change)="handleInputChange($event)">

<div class="row" *ngIf="docUrl">
    <div class="col">
        <a [href]="docUrl" target="_blank">Download document</a>
    </div>
    <div class="col">
        <button type="button" nbButton size="medium" status="danger" (click)="deleteFile()">Delete</button>
    </div>
</div>
<ng-container *ngIf="progress as percent">
    <div class="row">
        <progress [value]="percent" max="100"></progress>
    </div>
</ng-container>
